import { render, staticRenderFns } from "./VersionTable.vue?vue&type=template&id=de70ab66&"
import script from "./VersionTable.vue?vue&type=script&lang=js&"
export * from "./VersionTable.vue?vue&type=script&lang=js&"
import style0 from "./VersionTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports